export default function AccountResetPasswordRequestController(
    $scope,
    $location,
    $q,
    $routeParams,
    siteService
) {
    $scope.formHolder = {};

    $scope.siteService = siteService;

    siteService.getPage(93).then((res) => {
        // if user is allready logged in
        if (res.articleItems[0]) {
            // bool
            $scope.sidebarContent = res.articleItems[0].articleSections[0];
        }
    });
}
